import React from 'react';
import FeatherIcon from 'feather-icons-react';
import {
  AccessControlIcon,
  CompanyIcon,
  HomeIcon,
  MembersIcon,
  NotificationIcon,
  ParnerIcon,
  PassengerIcon,
  RoleIcon,
} from '@/assets/icons/entities/_';
import { MenuGroupProps } from '../__base';
import { GlobalPermissionConfig, GlobalUrl } from '@/routers/globalRouters';

export const OperationMenu: MenuGroupProps[] = [
  {
    groupName: 'menu.MainMenu',
    items: [
      {
        icon: <HomeIcon />,
        title: 'menu.Dashboard',
        key: 'dashboard',
        to: GlobalUrl.Operations.Dashboard,
        permissions: GlobalPermissionConfig.__getPermission(GlobalUrl.Operations.Dashboard),
      },
    ],
  },

  {
    groupName: 'menu.SystemSettings',
    items: [
      {
        icon: <MembersIcon />,
        title: 'menu.AdminUsers',
        key: 'admin-users',
        to: GlobalUrl.Operations.AdminUsers,
        permissions: GlobalPermissionConfig.__getPermission(GlobalUrl.Operations.AdminUsers),
      },
      {
        icon: <AccessControlIcon />,
        title: 'menu.AccessControl',
        key: 'access-control',
        to: GlobalUrl.Operations.AccessControl,
        permissions: GlobalPermissionConfig.__getPermission(GlobalUrl.Operations.AccessControl),
      },
      {
        icon: <ParnerIcon />,
        title: 'menu.Partners',
        key: 'partners',
        to: GlobalUrl.Operations.Partners,
        permissions: GlobalPermissionConfig.__getPermission(GlobalUrl.Operations.Partners),
      },
      {
        icon: <CompanyIcon />,
        title: 'menu.Companies',
        key: 'companies',
        to: GlobalUrl.Operations.Companies,
        permissions: GlobalPermissionConfig.__getPermission(GlobalUrl.Operations.Companies),
      },
      {
        icon: <PassengerIcon />,
        title: 'menu.Passengers',
        key: 'passengers',
        to: GlobalUrl.Operations.Passengers,
        permissions: GlobalPermissionConfig.__getPermission(GlobalUrl.Operations.Passengers),
      },
      {
        icon: <NotificationIcon />,
        title: 'menu.Notifications',
        key: 'notifications',
        to: GlobalUrl.Operations.Notification,
        permissions: GlobalPermissionConfig.__getPermission(GlobalUrl.Operations.Notification),
      },
      {
        icon: <RoleIcon />,
        title: 'menu.CompanyRoles',
        key: 'company-roles',
        to: GlobalUrl.Operations.CompanyRole,
        permissions: GlobalPermissionConfig.__getPermission(GlobalUrl.Operations.CompanyRole),
      },
    ],
  },
];
